import React from "react";
import HeroBanner from "../../components/HeroBanner/HeroBanner";
import HorizontalCard from "../../components/HorizontalCard/HorizontalCard";
import TextCard from "../../components/TextCard/TextCard";
import ImageCard from "../../components/ImageCard/ImageCard";

function About() {
  return (
    <>
      <HeroBanner
        title="About Us"
        subtitle="bricksnmix is built to make everyday shopping simple, reliable, and affordable. We combine a wide product selection with fast delivery and dependable customer support to give you a hassle-free shopping experience."
      />

      <HorizontalCard
        image="/images/slideimages/slide3.png"
        head="About"
        title="Get to know Bricksnmix"
        description="Bricksnmix was created with a simple goal: to make online shopping easier for everyone. We focus on offering quality products, transparent pricing, and timely delivery so customers can shop with confidence. From daily essentials to lifestyle products, we ensure every order meets our standards of reliability and service."
      />

      <br />
      <br />

      <div className="container mx-auto mb-10 px-4">
        <h1 className="mb-3 text-center text-3xl font-bold md:text-start">
          Our Client Reviews
        </h1>

        <div className="flex flex-col gap-4 px-4 py-4 md:flex-row md:justify-start">
          <TextCard text="Shopping on Bricksnmix has been smooth and reliable. The delivery was on time, and the product quality matched exactly what was shown on the website." />
          <TextCard text="I appreciate how easy it is to place orders and track them. Customer support was responsive and resolved my issue without unnecessary delays." />
          <TextCard text="Bricksnmix has become my go-to platform for everyday purchases. The pricing is fair, and the overall experience feels trustworthy." />
        </div>

        <br />
        <br />

        {/* <h1 className="mb-6 text-center text-3xl font-bold">
          Our Leadership
        </h1>

        <div className="flex flex-col gap-4 md:flex-row md:justify-center">
          <ImageCard
            image="/images/lead/lead1.png"
            name="John Doe"
            subtitle="Founder & CEO"
          />
          <ImageCard
            image="/images/lead/lead2.png"
            name="Jane Smith"
            subtitle="Operations Head"
          />
          <ImageCard
            image="/images/lead/lead1.png"
            name="Alice Johnson"
            subtitle="Customer Experience Lead"
          />
        </div> */}
      </div>
    </>
  );
}

export default About;

